import { NavLink } from "react-router-dom";

const NotificationStrip = ({ message, navlink, navBtnText }) => {
  return (
    <div className="bg-infokeyYellow bg-opacity-95 w-full px-2 py-1 fixed bottom-0 flex flex-wrap justify-center items-center gap-3 z-10">
      <p className="text-center">{message}</p>
      <NavLink to={navlink}>
        <button className="my-button-style-4">{navBtnText}</button>
      </NavLink>
    </div>
  );
};

export default NotificationStrip;
